var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.Open,
            width: _vm.width ? _vm.width : "60%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.Open = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "configForm",
              attrs: {
                "label-width": "120px",
                model: _vm.formModel,
                rules: _vm.labelRules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                _vm._l(_vm.config, function (item, index) {
                  return _c(
                    "el-col",
                    { key: index, attrs: { span: item.span ? item.span : 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: item.label, prop: item.prop } },
                        [
                          item.type === "text"
                            ? _c(
                                "el-input",
                                {
                                  attrs: {
                                    maxlength: item.maxlength,
                                    "show-word-limit": item.showWordLimit,
                                    disabled: item.disabled,
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请输入",
                                  },
                                  nativeOn: {
                                    input: function ($event) {
                                      item.oninput
                                        ? (_vm.formData[item.prop] =
                                            item.oninput($event.target.value))
                                        : null
                                    },
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                [
                                  item.rightText
                                    ? _c("template", { slot: "append" }, [
                                        _vm._v(
                                          " " + _vm._s(item.rightText) + " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          item.type === "textAznum"
                            ? _c("el-input", {
                                attrs: {
                                  maxlength: item.maxlength,
                                  disabled: item.disabled,
                                  placeholder: item.placeholder
                                    ? item.placeholder
                                    : "请输入",
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    _vm.formData[item.prop] =
                                      _vm.checkInputEnglish($event)
                                  },
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.type === "textAz"
                            ? _c("el-input", {
                                attrs: {
                                  maxlength: item.maxlength,
                                  disabled: item.disabled,
                                  placeholder: item.placeholder
                                    ? item.placeholder
                                    : "请输入",
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    _vm.formData[item.prop] =
                                      _vm.checkInputEnglishB($event)
                                  },
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.type === "textCN"
                            ? _c("el-input", {
                                attrs: {
                                  maxlength: item.maxlength,
                                  disabled: item.disabled,
                                  "show-word-limit": "",
                                  placeholder: item.placeholder
                                    ? item.placeholder
                                    : "请输入",
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    _vm.formData[item.prop] =
                                      _vm.checkInputCN($event)
                                  },
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.type === "textNum"
                            ? _c(
                                "el-input",
                                {
                                  attrs: {
                                    maxlength: item.maxlength,
                                    disabled: item.disabled,
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请输入",
                                    "show-word-limit": "",
                                  },
                                  nativeOn: {
                                    input: function ($event) {
                                      _vm.formData[item.prop] =
                                        _vm.checkInputNum($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                [
                                  item.rightText
                                    ? _c("template", { slot: "append" }, [
                                        _vm._v(
                                          " " + _vm._s(item.rightText) + " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          item.type === "textNum."
                            ? _c(
                                "el-input",
                                {
                                  attrs: {
                                    maxlength: item.maxlength,
                                    disabled: item.disabled,
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请输入",
                                  },
                                  nativeOn: {
                                    input: function ($event) {
                                      _vm.formData[item.prop] =
                                        _vm.checkInputPrice(
                                          $event,
                                          item.num ? item.num : 3
                                        )
                                    },
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                [
                                  item.rightText
                                    ? _c("template", { slot: "append" }, [
                                        _vm._v(
                                          " " + _vm._s(item.rightText) + " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          item.type === "textarea"
                            ? _c("el-input", {
                                attrs: {
                                  maxlength: item.maxlength,
                                  disabled: item.disabled,
                                  placeholder: item.placeholder
                                    ? item.placeholder
                                    : "请输入",
                                  rows: "4",
                                  "show-word-limit": "",
                                  type: "textarea",
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.type === "switch"
                            ? _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.type === "switch" && item.text
                            ? _c("div", { staticClass: "text-muted f12" }, [
                                _vm._v(" " + _vm._s(item.text) + " "),
                              ])
                            : _vm._e(),
                          item.type === "city"
                            ? _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: "small",
                                  "show-all-levels": item.showAllLevels,
                                  props: {
                                    checkStrictly: item.props.checkStrictly,
                                    multiple: item.props.multiple,
                                    value: item.props.value
                                      ? item.props.value
                                      : "ID",
                                    children: item.props.children
                                      ? item.props.children
                                      : "children",
                                    label: item.props.label
                                      ? item.props.label
                                      : "label",
                                  },
                                  options: item.options,
                                  placeholder: "全部",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.type === "checkbox"
                            ? _c(
                                "el-checkbox-group",
                                {
                                  attrs: {
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请选择",
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                _vm._l(item.data, function (option) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: option.id,
                                      attrs: { label: option.id },
                                    },
                                    [_vm._v(" " + _vm._s(option.name) + " ")]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                          item.type === "radio"
                            ? _c(
                                "el-radio-group",
                                {
                                  attrs: {
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请选择",
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                _vm._l(item.data, function (option) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: option.id,
                                      attrs: { label: option.id },
                                    },
                                    [_vm._v(" " + _vm._s(option.name) + " ")]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                          item.type === "select"
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请选择",
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                _vm._l(item.data, function (option) {
                                  return _c("el-option", {
                                    key: item.optionConfig
                                      ? option[`${item.optionConfig.id}`]
                                      : option.id,
                                    attrs: {
                                      label: item.optionConfig
                                        ? option[`${item.optionConfig.label}`]
                                        : option.label,
                                      value: item.optionConfig
                                        ? option[`${item.optionConfig.id}`]
                                        : option.id,
                                      disabled: option.disabled,
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          item.type === "dict"
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请选择",
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                _vm._l(
                                  _vm.dictData[item.dictKey],
                                  function (selectOption, i) {
                                    return _c("el-option", {
                                      key: i,
                                      attrs: {
                                        label: selectOption.desc,
                                        value: selectOption.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          item.type === "dictLog"
                            ? _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: item.placeholder
                                      ? item.placeholder
                                      : "请选择",
                                  },
                                  model: {
                                    value: _vm.formData[item.prop],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, item.prop, $$v)
                                    },
                                    expression: "formData[item.prop]",
                                  },
                                },
                                _vm._l(
                                  _vm.dictData[item.dictKey],
                                  function (selectOption, i) {
                                    return _c("el-option", {
                                      key: i,
                                      attrs: {
                                        label: selectOption.desc,
                                        value: selectOption.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          item.type === "datepicker"
                            ? _c("el-date-picker", {
                                attrs: {
                                  placeholder: item.placeholder
                                    ? item.placeholder
                                    : "请选择日期",
                                  type: "date",
                                },
                                model: {
                                  value: _vm.formData[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, item.prop, $$v)
                                  },
                                  expression: "formData[item.prop]",
                                },
                              })
                            : _vm._e(),
                          item.tipText
                            ? _c("div", { staticClass: "tip-text-color" }, [
                                _vm._v(" " + _vm._s(item.tipText) + " "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _vm.formData &&
              _vm.formData.assetType &&
              _vm.formData.assetType == 4
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.btnLoading, type: "primary" },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v(" 确定并生成请款OA ")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.btnLoading, type: "primary" },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v(" 确 定 ")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }